




















import { Component, Prop, Vue } from "vue-property-decorator";

import IconSearched from "@/components/icons/IconSearched.vue";
import { Table as CatalogTable } from "@/components/organisms/Table";

import { ITableRow } from "@/components/organisms/Table/interfaces";
import { View } from "@/components/organisms/Table/enums";

import { catalogModule, complaintsModule } from "@/plugins/store-accessors";
import { defaultHeaders } from "./mocks";
import IconRefresh from "@/components/icons/IconRefresh.vue";

@Component({
  name: "documents",
  components: {
    IconRefresh,
    CatalogTable,
    IconSearched,
  },
})
export default class ProductList extends Vue {
  tableViewType: View = View.file;
  tableHeaders = defaultHeaders;

  get rows(): ITableRow[] {
    return [
      ...this.addTypeProp(complaintsModule.getUpperCategories, "upperCategory"),
      ...this.addTypeProp(complaintsModule.getCategories, "category"),
      ...this.addTypeProp(complaintsModule.getFiles, "product"),
    ];
  }

  changeQuantity(pl: { id: number; val: number }) {
    return catalogModule.changeQuantity(pl);
  }

  setType(view: View) {
    this.tableViewType = view;
    localStorage.setItem("viewType", view);
  }

  getSlug(row?: ITableRow) {
    if (!row) {
      return "";
    }
    return row.slug || row.id;
  }

  getContext() {
    switch (this.$route.name) {
      case "digital-catalog":
      case "digital-catalog-detail":
        return "digital-catalog";
      default:
        return "complaints";
    }
  }

  rowClickHandler(row: ITableRow, index: number) {
    const context = this.getContext();
    const query = { ...this.$route.query };
    delete query.page;

    if (row.type === "category") {
      this.$router.push({
        path: `/${context}/${this.getSlug(row)}/`,
        query: query,
      });
    } else if (row.type === "upperCategory") {
      const slug = this.getSlug(this.rows[index - 1]);
      if (slug) {
        this.$router.push({
          path: `/${context}/${slug}/`,
          query: query,
        });
      } else {
        this.$router.push({
          path: `/${context}/`,
          query: query,
        });
      }
    }
  }

  addTypeProp(rows: ITableRow[], type: string): ITableRow[] {
    return rows.map((row: ITableRow, index: number): ITableRow => {
      return { ...row, type, index } as ITableRow;
    });
  }
}
